import React, { useCallback, useEffect, useRef, useState } from "react";
import { BoxedStyled } from "../../../style/components/common.styled";
import styled from "styled-components";
import userStore from "../../../stores/user.store";
import { PrimaryButtonStyled } from "../../../style/components/button.styled";
import { getCurrentUser } from "../../../servises/auth.service";
import { addToast } from '../../components/toasts/Toast';

const Styles = styled.div`
  text-align: center;
  padding: 30px;
  font-size: 19px;

  button {
    margin-top: 60px;
  }
`;

const VerifyEmailAskPage = props => {
    if (userStore.user && userStore.emailVerified) {
        props.history.push("/servers");
        // return;
    }

    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const resendTimerRef = useRef(null);

    useEffect(() => {
        const sentEmail = localStorage.getItem("emailSentIn");
        const dateNow = Date.now();
        const emailSentNum = sentEmail ? Number(sentEmail) : 0;
        const timeOut = Math.max(0, 120000 - (dateNow - emailSentNum));

        const timer = setTimeout(() => {
            setButtonDisabled(false);
        }, timeOut);
        return () => {
            clearTimeout(timer);
            clearTimeout(resendTimerRef.current);
        };
    }, []);

    const handleSubmit = useCallback(async () => {
        if (isSending) {
            return;
        }

        setIsSending(true);
        try {
            const user = getCurrentUser();
            await user.sendEmailVerification();
            localStorage.setItem("emailSentIn", Date.now().toString());
            setButtonDisabled(true);
            resendTimerRef.current = setTimeout(() => {
                setButtonDisabled(false);
            }, 120000);
        } catch (error) {
            addToast(error.message || 'Failed to send verification email', 'error');
        } finally {
            setIsSending(false);
        }
    }, [isSending]);

    const logout = () => {
        return userStore.doLogOut('/login');
    };

    return (
        <BoxedStyled>
            <Styles>
                <h1>We sent you an email, please verify</h1>

                { !buttonDisabled && !isSending && (
                    <PrimaryButtonStyled
                        onClick={ handleSubmit }
                    >
                        Send verification email again
                    </PrimaryButtonStyled>
                ) }

                <div className="logout-button">
                    <PrimaryButtonStyled
                        onClick={ logout }
                    >
                        Logout
                    </PrimaryButtonStyled>
                </div>
            </Styles>
        </BoxedStyled>
    );
};
// http://localhost:3000/pik?mode=verifyEmail&oobCode=y4eBnckh4ToN9RkNnNjNzJ3Bus5X06Mlh3IhXsGMyCcAAAF3RYkgXA&apiKey=AIzaSyDuXWbbtUFQe3K7w80p41SBfFwCKCSmFT8&lang=en

export default VerifyEmailAskPage;
